import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	filterDetails: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterDetails: {
		id: 'issue-navigator-custom-filters.details-popup.filter-details',
		defaultMessage: 'Filter details',
		description: 'Text of button that opens the filter details popup',
	},
});
export default messages;
